<template>
  <div class="secondaryNavigation">
    <ul class="nav navbar-nav" v-if="hasAcceptedTerms">
      <li class="nav-item">
        <router-link class="nav-link" :to="'/'+this.$store.state.language+'/supplier/dashboard'">{{t('Dashboard')}}</router-link>
      </li>
      <li class="nav-item">
        <router-link class="nav-link" id="navLinkActivities" :to="'/'+this.$store.state.language+'/supplier/activities'">{{t('Activities')}}</router-link>
      </li>
      <li class="nav-item"><router-link class="nav-link" :to="`/${language}/supplier/bookings`">{{t('Bookings')}}</router-link></li>
      <li class="nav-item"><router-link class="nav-link" :to="'/'+$store.state.language+'/supplier/activities/calendar'">{{t('Calendar')}}</router-link></li>
      <li class="nav-item"><router-link class="nav-link" :to="'/'+$store.state.language+'/supplier/payments'">{{t('Payments')}}</router-link></li>
    </ul>
    <ul class="nav navbar-nav navbarDisabled" v-if="!hasAcceptedTerms">
      <li class="nav-item">
        {{t('Dashboard')}}
      </li>
      <li class="nav-item">
        {{t('Activities')}}
      </li>
      <li class="nav-item">{{t('Bookings')}}</li>
      <li class="nav-item">{{t('Calendar')}}</li>
      <li class="nav-item">{{t('Payments')}}</li>
      <li class="nav-item pleaseAcceptTerms"><small>({{t('please accept the terms of use before continuing')}})</small></li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'SecondaryNavigation',
    components: {},
    data() {
      return {
      };
    },
    computed: {
      ...mapState({
        language: state => state.language,
        hasAcceptedTerms: state => state.user.data.hasAcceptedTerms,
      }),
    },
    mounted() {
      if (!this.hasAcceptedTerms) {
        if (this.$route.path === '/pt/supplier/dashboard' &&
         this.$route.path !== '/en/supplier/dashboard'
         ) {
          window.location = `/${this.language}/supplier/settings`;
        }
      }
    },
};
</script>

<style lang="scss" scoped>
  .secondaryNavigation {
    clear: both;
    width: 100%;
    .nav {
      padding-top: 8px;
      padding-bottom: 15px;
      padding-left: 30px;
      padding-right: 30px;
      background-color: lighten(#00695C, 5%);
      min-height: 50px;
      li {
        display: inline-block;
        a {
          color: white;
        }
      }
    }
  }
  .text-muted {
    color: rgba(white, 0.5) !important;
  }
  .navbarDisabled li {
    padding-top: 4px;
    color: white;
    opacity: 0.5;
  }
  .navbarDisabled .pleaseAcceptTerms {
    opacity: 1;
    small {
      font-weight: 200;
      letter-spacing: 0.01em;
    }
  }
  .router-link-active {
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// SecondaryNavigation.vue?296c6370